import { AgsAlternateAnimateBehaviour } from "ags/behaviours/ags-alternate-animate-behaviour";
import { AnimateWinsComponent } from "ags/components/animate-wins-component";
import { Components } from "appworks/components/components";
import { ThemeFiniteAnimationBehaviour } from "behaviours/theme-finite-animation-behaviour";
import { ThemeWinCyclePulseSymbolBehaviour } from "behaviours/theme-win-cycle-pulse-symbol-behaviour";
import { ThemeCelebrateWinComponent } from "components/theme-celebrate-win-component";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";

export class ThemeAnimateWinsComponent extends AnimateWinsComponent {
    constructor(protected alternateAnimation = true) {
        super();
    }

    public override end(): void {
        const symbols = Components.get(MatrixComponent).getAllSymbols();
        symbols.forEach((symbol) => {
            symbol.static();
            symbol.removeBehaviourOfType(AgsAlternateAnimateBehaviour);
        });
    }

    protected override setSymbolBehaviours(): void {
        const wins = this.getAllWins();
        wins.forEach((win) => {
            for (const position of win.positions) {
                const symbol = Components.get(MatrixComponent).getSymbol(position.x, position.y);
                symbol.removeBehaviourOfType(AgsAlternateAnimateBehaviour);

                if (this.alternateAnimation) {
                    symbol.addBehaviour(new AgsAlternateAnimateBehaviour(symbol));
                }
            }

            if (this.alternateAnimation) {
                this.alternateAnimation = !this.alternateAnimation;
            }
        });
    }
}
